/**
 * Estilos compartidos del menú lateral.
 *
 * Viven aparte de los componentes para no romper el Fast Refresh (un archivo que
 * exporta componentes **y** constantes deja de ser recargable en caliente).
 */

import { cn } from '@/lib/utils';

export const SIDEBAR_LINK_BASE = 'group flex items-center gap-3 rounded-lg px-3 transition-colors';


const IDLE = 'text-white/65 hover:bg-white/[0.07] hover:text-white';
const ACTIVE = 'bg-brand-500/15 text-white ring-1 ring-brand-400/30';

export function sidebarLinkClasses(isActive: boolean): string {
  return cn(SIDEBAR_LINK_BASE, isActive ? ACTIVE : IDLE);
}

/** Color del icono en reposo / activo. */
export const SIDEBAR_ICON_IDLE = 'text-white/45 group-hover:text-white/80';
export const SIDEBAR_ICON_ACTIVE = 'text-brand-300';
